<template>
<div v-if="activity" class="speech-container">
    <div v-if="!isCurrentUser" class="mr-3 pt-1 ml-1">
        <ContactImage :contact="currentUser" :size="33" />
    </div>
    <div class="speech-bubble" :class="{'current-user': isCurrentUser, 'other-user': !isCurrentUser}">
        {{activity.description}}
    </div>
    <div v-if="isCurrentUser" class="ml-3 pt-1">
        <ContactImage :contact="currentUser" :size="33" />
    </div>
</div>
</template>

<script>
import DataHelpers from '@/helpers/DataHelpers'
import ContactImage from './ContactImage'

export default {
    data() {
        return {
        
        }
    },

    components: {
        ContactImage
    },
    
    props: {
        activity: Object,
    },

    computed: {
        isCurrentUser() {
            return false
        },
        currentUser() {
            return DataHelpers.getUser()
        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>

.speech-container {
    display:flex;
    font-size:14px;
}

.speech-bubble {
	position: relative;
	background: rgba(0,0,0,0.06);
	border-radius: .4em;
    padding:8px 12px;
}
.speech-bubble.current-user {
	background: #badbfa;
}

.speech-bubble:after {
	content: '';
	position: absolute;
	top: 20px;
	width: 0;
	height: 0;
	border: 10px solid transparent;
	margin-top: -10px;

}

.speech-bubble.other-user:after {
    left: 0;
	border-right-color: rgba(0,0,0,0.06);
	border-left: 0;
	margin-left: -10px;
}

.speech-bubble.current-user:after {
	right: 0;
	border-left-color: #badbfa;
	border-right: 0;
    margin-right: -10px;
}
   
</style>




// WEBPACK FOOTER //
// SpeechBubble.vue?4c53d127